export const API_KEY = 'c686fd0cacddd11fd41af6fdd62727e4';
export const BASE_URL = 'https://api.themoviedb.org/3';
export const ID_URL = `${BASE_URL}/movie/`;

/*  Пример API-запроса https://api.themoviedb.org/3/movie/550?api_key=c686fd0cacddd11fd41af6fdd62727e4 ,
подробнее в документации API */
